import TableReviewBlock from './table-review-block'

export default TableReviewBlock
